/*
 * Public API Surface of language-header
 */

export * from './lib/language-header.component';
export * from './lib/language-header.module';
